import axios, { AxiosRequestConfig } from 'axios';

export interface IApiResponse {
    data: any;
    error: boolean;
}

let instance = axios.create ({
    baseURL: process.env.REACT_APP_API_BASE_URL,
    headers: {
        "content-type":"application/json"
    },
    responseType: "json"
});

instance.interceptors.request.use((config: AxiosRequestConfig) => {
    const userData = localStorage.getItem("currentUser");
    const token: string = userData ? JSON.parse(userData).accessToken.trim() : '';
    config.headers.Authorization = token.length > 0 ? `Bearer ${token}` : token;
    return config;
});

export const Api = {
    get: (url: string) => instance.get(url),
    post: (url: string, data: any) => instance.post(url, data),
}